import { render } from "./FranchiseeView.vue?vue&type=template&id=0a944ac2&scoped=true"
import script from "./FranchiseeView.vue?vue&type=script&lang=js"
export * from "./FranchiseeView.vue?vue&type=script&lang=js"

import "./FranchiseeView.vue?vue&type=style&index=0&id=0a944ac2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a944ac2"]])

export default __exports__